<template>
  <section class="gallery-display">
    <aNewCarousel
      ref="main"
      :as-nav-for="asNavFor1"
      :options="mainSliderOptions"
      class="main-carousel"
    >
      <template
        slot="prevButton"
        type="div"
      >
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 50 50"
          style="enable-background:new 0 0 50 50;"
          xml:space="preserve"
          class="icon"
        >
          <line
            class="ls"
            x1="16.618"
            y1="25"
            x2="33.382"
            y2="7.895"
          />
          <line
            class="ls"
            x1="16.618"
            y1="25"
            x2="33.382"
            y2="42.105"
          />
        </svg>
      </template>
      <template
        slot="nextButton"
        title="Next Slide"
        alt="Next Slide"
        aria-label="Next Slide"
      >
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 50 50"
          style="enable-background:new 0 0 50 50;"
          xml:space="preserve"
          class="icon"
        >
          <line
            class="ls"
            x1="16.618"
            y1="7.895"
            x2="33.382"
            y2="25"
          />
          <line
            class="ls"
            x1="16.618"
            y1="42.105"
            x2="33.382"
            y2="25"
          />
        </svg>
      </template>
      <div
        v-for="(slide, index) in media"
        :key="index"
        class="slide feature-slide"
        :class="`slide--${index}`"
      >
        <template v-if="slide.type === 'youtube'">
          <b-btn
            class="play"
            title="Play Video"
            @click="triggerVideoModal(slide)"
          >
            <div class="play-icon">
              <svg
                class="icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16.021 18.193"
              >
                <path
                  d="M0,9.1V1A1,1,0,0,1,1.5.135L8.511,4.183l7.01,4.048a1,1,0,0,1,0,1.732L8.511,14.01,1.5,18.058A1,1,0,0,1,0,17.192Z"
                />
              </svg>
            </div>
          </b-btn>
        </template>
        <AImage
          :img="slide.image"
          :preset="getPreset(slide.image)"
          :ratio="getRatio(slide.image)"
          tag="img"
          class="feature-image display-image"
          cover
        />
      </div>
    </aNewCarousel>
    <aNewCarousel
      ref="thumbnails"
      :as-nav-for="asNavFor2"
      :options="thumbnailSliderOptions"
      class="navigation-carousel"
    >
      <template
        slot="prevButton"
        type="div"
      >
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 50 50"
          style="enable-background:new 0 0 50 50;"
          xml:space="preserve"
          class="icon"
        >
          <line
            class="ls"
            x1="16.618"
            y1="25"
            x2="33.382"
            y2="7.895"
          />
          <line
            class="ls"
            x1="16.618"
            y1="25"
            x2="33.382"
            y2="42.105"
          />
        </svg>
      </template>
      <template
        slot="nextButton"
        title="Next Slide"
        alt="Next Slide"
        aria-label="Next Slide"
      >
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 50 50"
          style="enable-background:new 0 0 50 50;"
          xml:space="preserve"
          class="icon"
        >
          <line
            class="ls"
            x1="16.618"
            y1="7.895"
            x2="33.382"
            y2="25"
          />
          <line
            class="ls"
            x1="16.618"
            y1="42.105"
            x2="33.382"
            y2="25"
          />
        </svg>
      </template>
      <div
        v-for="(slide, index) in media"
        :key="index"
        class="slide slide-thumbnail"
        :class="`slide--${index}`"
        @click="$refs.thumbnails.goTo(index)"
      >
        <AImage
          :img="slide.image"
          :preset="getPreset(slide.image)"
          :ratio="getRatio(slide.image)"
          tag="img"
          class="thumb-image"
          cover
        />
      </div>
    </aNewCarousel>
    <videoModal
      ref="galleryVideoModal"
      :src="modalVideo.src"
      @videoModalHidden="videoModalHidden"
    />
  </section>
</template>

<script>
import stylesMixin from './styles-mixin'

// This is imported like this because refs in vue do not work with dynamic imports.
import aNewCarousel from 'dev/common-components/src/components/a-carousel/0001/ACarousel.vue'
import videoModal from './components/videoModal'

export default {
  name: 'slice-type-gallery-style-landscape-thumb-carousel',
  components: {
    aNewCarousel,
    videoModal
  },
  mixins: [
    stylesMixin
  ],
  data() {
    return {
      asNavFor1: [],
      asNavFor2: [],
      mainSliderOptions: {
        dots: false,
        fade: false,
        navButtons: true,
        slidesToShow: 1,
        infinite: false,
        autoplay: false
      },
      thumbnailSliderOptions: {
        autoplay: false,
        centerMode: false,
        dots: false,
        navButtons: true,
        slidesToShow: 2,
        infinite: false,
        responsive: [
          {
            breakpoint: 562,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 5
            }
          }
        ]
      },
      modalVideo: {
        src: ''
      }
    }
  },
  computed: {
    modalVideoActive: {
      set(val) {
        this.modalVideo.active = val
      },
      get() {
        return this.modalVideo.active
      }
    }
  },
  mounted() {
    this.asNavFor1.push(this.$refs.thumbnails)
    this.asNavFor2.push(this.$refs.main)
  },
  methods: {
    triggerVideoModal(slideData) {
      if (slideData && slideData.type === 'youtube' && Object.keys(slideData).includes('video') && slideData.video.src !== '') {
        this.modalVideo.src = `https://www.youtube.com/embed/${slideData.video.src.split('/').pop()}?autoplay=1&amp;modestbranding=1&amp;showinfo=0`
        this.$refs.galleryVideoModal.activate()
      }
    },
    videoModalHidden() {
      this.modalVideo.src = ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";

.gallery-display {
  --play-icon-color: #fff;
  --play-icon-border-color: #fff;
  --navigation-over-image: #fff;

 ::v-deep .acarousel__actions {
    display: flex;
    align-items: center;
    position: absolute;
    height: 100%;
    top: 0;
    width: 100%;
    pointer-events: none;
  }
 ::v-deep .acarousel__nav-button {
    height: 3em;
    display: flex;
    align-content: space-between;
    all: unset;
    cursor: pointer;
    padding: 1em;
    color: white;
    z-index: 3;
    pointer-events: visible;
    transform: scale(1);
    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
    opacity: 0;
    svg {
      width: 2em;
    }
    @include hover-focus {
      transform: scale(1.25);
      &[disabled] {
        opacity: 0.25;
      }
    }
    .icon {
      .ls {
        fill: var(--navigation-over-image);
        stroke: var(--navigation-over-image);
      }
    }
    &[disabled] {
      opacity: 0.1;
      cursor: not-allowed;
    }
  }
  @include hover-focus {
   ::v-deep .acarousel__nav-button {
      opacity: 1;
    }
  }
}
.click-through {
  @include hover-focus {
    .play {
      transform: scale(1.2);
    }
  }
}

.play {
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  z-index: 2;
  transform-origin: center;
  background: transparent;
  background-color: transparent;
  transition: transform 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    background: transparent !important;
    background-color: transparent !important;
  }
}

.play-icon {
  width: 5em;
  height: 5em;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 100%;
  box-shadow: 0px 0px 3px 2px rgba(20, 20, 20, 0.1);
  border: 3px solid var(--play-icon-border-color);
  z-index: 3;
  .icon {
    width: 1.5em;
    height: 1.5em;
    fill: var(--play-icon-color);
  }
}

.display-image {
  background: var(--gallery-background-image-color);
  object-fit: cover;
  //we default it to 50%
  position: relative;
  object-position: 50% 50%;
  width: 100%;
  height: 400px;
  @include media-breakpoint-up(md) {
    height: 700px;
  }
}

.image-gallery {
  padding: 3em 0em;
}

.main-carousel {
  margin-bottom: 1em;
  @include media-breakpoint-up(md) {
    margin-bottom: 2em;
  }
  overflow: hidden;
  .slide {
    width: 100%;
  }

  &.acarousel--ssr .acarousel__slides > * {
    overflow: hidden;
    width: 0;
  }

  &.acarousel--ssr .acarousel__slides > *:first-child {
    width: 100%;
  }
}

.navigation-carousel {
  overflow: hidden;
  position: relative;
  margin: 0 -0.5em;
  width: calc(100% + 1em);

  @include media-breakpoint-up(lg) {
    margin: 0 -1em;
    width: calc(100% + 2em);
  }

  .slide img {
    height: 100%;
    object-fit: cover;
    object-position: center;
    width: 100%;
  }

  .slide-thumbnail {
    height: 5.5em;
    padding: 0px 0.5em;
    cursor: pointer;
    z-index: 4;

    @include media-breakpoint-up(sm) { height: 5.5em; }
    @include media-breakpoint-up(md) { height: 7.5em; }
    @include media-breakpoint-up(lg) { padding: 0px 1em; }
  }
  //styling for SSR / placeholder display of carousel
  &.acarousel--ssr {
    .acarousel__slides > * {
      overflow: hidden;
      width: 0;
      padding: 0;
    }
    .acarousel__slides {
      > *:nth-child(-n + 3) {
        width: 33.33%;
        padding: 0px 0.5em;
      }
      @include media-breakpoint-up(lg) {
        > *:nth-child(-n + 5) {
          width: 20%;
          padding: 0px 1em;
        }
      }
    }
  }
}

.thumb-image {
  background: var(--gallery-background-image-color);
  object-fit: cover;
  opacity: 0.5;
  transition: opacity 0.3s ease-in-out;
  &:hover {
    opacity: 1;
  }
}
.acarousel__slide--active {
  .thumb-image {
    opacity: 1;
  }
}
</style>
